<div class="combine-chart-component">
  <div class="legend">
    <div
      class="legend-item"
      *ngFor="let legend of data.legend"
      #legendItem
      (click)="onLegendClick(legend)"
      (mouseover)="onMouseOver($event)"
      (mouseout)="onMouseOver($event)"
      [ngClass]="legend.selected ? '' : 'inactive'"
    >
      <span
        class="legend-color"
        [ngStyle]="getLegendColorStyle(legendItem, legend)"
      >
      </span>
      <span
        class="legend-text"
        [innerHTML]="legend.name + ' ' + legend.value"
      ></span>
    </div>
    <div
      class="show-all"
      (click)="onShowAllClick()"
      (mouseover)="onMouseOver($event)"
      (mouseout)="onMouseOver($event)"
      [ngClass]="showAllEnabled ? '' : 'inactive'"
    >
      <span class="show-all-text">
        <i class="fa fa-refresh" data-icon></i> Show All
      </span>
    </div>
  </div>
  <svg class="chart">
    <defs>
      <filter id="dropshadow" height="130%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="2"></feGaussianBlur>
        <feOffset dx="0.5" dy="0.5" result="offsetBlur"></feOffset>
        <feComponentTransfer>
          <feFuncA type="linear" slope="0.4"></feFuncA>
        </feComponentTransfer>
        <feMerge>
          <feMergeNode></feMergeNode>
          <feMergeNode in="SourceGraphic"></feMergeNode>
        </feMerge>
      </filter>
    </defs>
  </svg>
</div>
